"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react")),
    _uiKit = require("@devsta/ui-kit");

require("../styles/_not-found.scss");

var HELP_URL = "https://intercom.help/shootstahub/en";

function goHome(history) {
  return function () {
    history.push("/");
  };
}

function openHelpPage() {
  window.open(HELP_URL, "_blank");
}

function NotFound(_ref) {
  var history = _ref.history;
  return _react["default"].createElement("div", {
    className: "not-found"
  }, _react["default"].createElement("div", {
    className: "not-found__inner"
  }, _react["default"].createElement(_uiKit.Icon, {
    className: "not-found__icon",
    name: "robot"
  }), _react["default"].createElement("div", {
    className: "not-found__text"
  }, _react["default"].createElement("p", {
    className: "not-found__header"
  }, "Hmm.. you seem to be lost."), _react["default"].createElement("p", {
    className: "not-found__suggest"
  }, "The page doesn't seem to exist."), _react["default"].createElement(_uiKit.Button, {
    onClick: goHome(history)
  }, "Go Home"))), _react["default"].createElement("p", {
    className: "not-found__assist"
  }, "If the problem persists, contact your dedicated Account Manager or visit our", " ", _react["default"].createElement("strong", null, _react["default"].createElement(_uiKit.LinkButton, {
    onClick: openHelpPage
  }, "Help Center")), " ", "for more information."));
}

var _default = (0, _react.memo)(NotFound);

exports["default"] = _default;